/* eslint-disable */
import { request } from "../api";
import { ADMIN_ENV, headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { StatusCodes } from "http-status-codes";
import { Plan, VEB_Plan, VEBPlan } from "../../../@types/plan.types";

const { post, get, put, del, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "plan";

export const getPlans = async (query: any): Promise<Plan[]> => {
	try {
		// console.log("query", query);
		const endpoint = `${initialRoute}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);

		// console.log("response PLans", response);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Unauthorised Role!") {
				alert("Unauthorised Role!");
			} else if (message === MESSAGE.get.empty) {
				alert("Database Empty");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to get members!");
			} else alert("Other Errors of Status Code 400");
		}
		throw error;
	}
};

export const addPlan = async (payload: FormData): Promise<Plan> => {
	try {
		const endpoint = `${initialRoute}`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		}
		throw error;
	}
};

/**
 * Create a Core plan built with the VEB structure ("Same as VEB Structure").
 * Distinct from `addPlan`, which creates a classic Core plan.
 * Expects multipart FormData with a JSON `plan` field and an optional `document`.
 */
export const addCorePlan = async (payload: FormData): Promise<Plan> => {
	try {
		const endpoint = `${initialRoute}/add-core-plan`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response?.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
			}
		}
		throw error;
	}
};

export const addVEBPlan = async (payload: FormData): Promise<VEB_Plan> => {
	try {
		const endpoint = `${initialRoute}/add-veb-plan`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		console.log(" hi bro form add-veb-plan");
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		}
		throw error;
	}
};

export type TerminatePlanPayload = {
	_id: string;
	end_date: string;
	group_number: number;
};

export const terminatePlan = async (payload: TerminatePlanPayload): Promise<Plan> => {
	try {
		const endpoint = `${initialRoute}/end-date`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.patch.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { err } = error.response.data;

			alert(err);
		}
		throw error;
	}
};

export const getPlansByStatus = async (query: Record<string, unknown>) => {
	try {
		const endpoint = `${initialRoute}/get-plans-by-status`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Unauthorised Role!") {
				alert("Unauthorised Role!");
			} else if (message === MESSAGE.get.empty) {
				alert("Database Empty");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to get members!");
			} else alert("Other Errors of Status Code 400");
		}
		throw error;
	}
};

export type TogglePlanStausPayloadType = {
	_id: string;
	plan_name: string;
	group_number: number;
	plan_status: string;
};

export const togglePlanStatus = async (togglePlanStatusPayload: TogglePlanStausPayloadType): Promise<any> => {
	try {
		const endpoint = `${initialRoute}/toggle-plan-status`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, togglePlanStatusPayload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.patch.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		throw error;
	}
};

export const getVEBPlans = async (query: Record<string, unknown>): Promise<VEBPlan[]> => {
	try {
		// console.log("Query", query);
		const endpoint = `${initialRoute}/veb-plans`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);

		if (response) {
			// console.log("Response", response);
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;

				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		throw error;
	}
};

export const getParticularPlans = async (query: any) => {
	try {
		const endpoint = `${initialRoute}/particular-plan`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			throw error;
		}
	}
};

export const updateVEBPlanDocument = async (payload: FormData): Promise<Plan> => {
	try {
		const endpoint = `${initialRoute}/update-plan-document`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		}
		throw error;
	}
};
export const updateVEBPlan = async (planId: string, payload: Record<string, any>): Promise<VEB_Plan> => {
	try {
		const endpoint = `${initialRoute}/update-veb-plan/${planId}`;
		const token = localStorage.getItem("@jwt");

		const response = await put(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});

		if (response) {
			const {
				data: { result }
			} = response;

			// Return the updated plan directly
			return result;
		}

		throw new Error("No response from server");
	} catch (error: any) {
		if (error.response?.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			alert(message || "Bad Request");
		}
		throw error;
	}
};

export const updateVEBPlanOrder = async (planId: string, payload: Record<string, any>): Promise<VEB_Plan> => {
	try {
		const endpoint = `${initialRoute}/update-veb-planorder/${planId}`;
		const token = localStorage.getItem("@jwt");

		const response = await patch(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});

		if (response) {
			const {
				data: { result }
			} = response;

			// Return the updated plan directly
			return result;
		}

		throw new Error("No response from server");
	} catch (error: any) {
		if (error.response?.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			alert(message || "Bad Request");
		}
		throw error;
	}
};

// updateVEBPlanOrder frontend
//

export const addPremiumAmountToVEBPlan = async (planId: string, payload: Record<string, any>): Promise<Plan> => {
	try {
		const endpoint = `${initialRoute}/update-veb-plan-addPremiumAmountToVEBPlan/${planId}`;
		const token = localStorage.getItem("@jwt");

		const response = await put(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});

		if (response) {
			return response.data; // ✅ updated plan directly
		}

		throw new Error("No response from server");
	} catch (error: any) {
		if (error.response?.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			alert(message || "Bad Request");
		}
		throw error;
	}
};

export const getPlansWithGroupInformation = async (query: Record<string, unknown>): Promise<any> => {
	try {
		const endpoint = `${initialRoute}/get-plans-with-group-information`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const getActiveVEBPlans = async (
	group_number: number | string
): Promise<{
	currentPlans: VEB_Plan[];
	futurePlans: VEB_Plan[];
}> => {
	try {
		if (!group_number) {
			throw new Error("group_number is required but not provided");
		}

		const endpoint = `${initialRoute}/veb-active-plans/${group_number}`;

		// const token = localStorage.getItem("@jwt_member");
		// if (!token) throw new Error("JWT token not found");

		const response = await get(endpoint, {
			...headers
			// Authorization: `Bearer ${token}`
		});

		if (response?.data?.message === MESSAGE.get.succ) {
			return response.data.data as {
				currentPlans: VEB_Plan[];
				futurePlans: VEB_Plan[];
			};
		}

		throw new Error("Failed to fetch active VEB plans");
	} catch (err) {
		console.error("Error in getActiveVEBPlans:", err);
		alert(err);
		throw err;
	}
};

export const getActivePlans = async (group_number: number | string): Promise<Plan[]> => {
	try {
		if (!group_number) {
			throw new Error("group_number is required but not provided");
		}

		const endpoint = `${initialRoute}/get-active-plans`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			{ group_number }
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error("Failed to fetch active plans");
	} catch (err) {
		console.error("Error in getActivePlans:", err);
		throw err;
	}
};


export const getActiveCorePlans = async (
	group_number: number | string
): Promise<{
	currentPlans: Plan[];
	futurePlans: Plan[];
}> => {
	try {
		if (!group_number) {
			throw new Error("group_number is required but not provided");
		}

		const endpoint = `${initialRoute}/core-active-plans/${ group_number }`;

		const response = await get(endpoint, {
			...headers
		});

		if (response?.data?.message === MESSAGE.get.succ) {
			return response.data.data as {
				currentPlans: Plan[];
				futurePlans: Plan[];
			};
		}

		throw new Error("Failed to fetch active CORE plans");
	} catch (err) {
		console.error("Error in getActiveCorePlans:", err);
		alert(err);
		throw err;
	}
};

export const plan = {
	getPlans,
	addPlan,
	addCorePlan,
	terminatePlan,
	getPlansByStatus,
	togglePlanStatus,
	getVEBPlans,
	updateVEBPlanOrder,
	getParticularPlans,
	addVEBPlan,
	updateVEBPlanDocument,
	updateVEBPlan,
	getActiveVEBPlans,
	getActivePlans,
	addPremiumAmountToVEBPlan,
	getPlansWithGroupInformation
};
